import React from "react";

const VectorShell = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
             {/* Main Fan Shape */}
             <path
                d="M20 35 C15 35 4 28 4 15 C4 5 12 2 20 2 C28 2 36 5 36 15 C36 28 25 35 20 35 Z"
                fill="#fff5f2ff"
                stroke="#E64A19"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            
            {/* Base/Hinge */}
            <path
                d="M15 35 L20 38 L25 35"
                fill="#FFCCBC"
                stroke="#E64A19"
                strokeWidth="1.5"
                 strokeLinejoin="round"
            />

            {/* Ridges */}
            <path d="M20 35 L20 2" stroke="#E64A19" strokeWidth="1" strokeLinecap="round" opacity="0.6"/>
            <path d="M20 35 L12 4" stroke="#E64A19" strokeWidth="1" strokeLinecap="round" opacity="0.6"/>
            <path d="M20 35 L28 4" stroke="#E64A19" strokeWidth="1" strokeLinecap="round" opacity="0.6"/>
            <path d="M20 35 L6 10" stroke="#E64A19" strokeWidth="1" strokeLinecap="round" opacity="0.6"/>
            <path d="M20 35 L34 10" stroke="#E64A19" strokeWidth="1" strokeLinecap="round" opacity="0.6"/>
        </svg>
    );
};

export default VectorShell;
